module.exports = __webpack_public_path__ + "img/ashen-gate.3821d807.webp";